import React from "react";
import { useNavigate } from "react-router-dom";
import "../../css/document-title/Main.css"; // Assuming you have a CSS file for styling

const Main = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/workflows");
  };

  return (
    <div className="">
      <div className="topbar">
        <div
          className="header-icon"
          onClick={handleBackClick}
          style={{ cursor: "pointer" }}
        >
          <div className="icon-back">
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M 12.6668 8.7749 H 3.3335 M 3.3335 8.7749 L 8.00016 13.4416 M 3.3335 8.7749 L 8.00016 4.10823" />
              </svg>
            </div>
            <div className="icon-text">Back</div>
          </div>
        </div>
        <div className="document-title">
          <div className="header">
            WF - 060981: BESS PLANT-PSS-FACTORY ACCEPTANCE TEST (FAT) REPORT
            SUBMISSION OF EMERGENCY DIESEL GENERATOR (500KVA), M/S. ALKHORAYEF
            COMMERCIAL CO., PM210012-LTG511-INC-BESS- 00033. (LOT-01)
          </div>
        </div>
      </div>
      <div class="workflow-detail-card">
        <div class="top-info">
          <div class="info-col1">
            <div>Initiator</div>
            <div>Number of documents</div>
            <div>Start Date</div>
            <div>End Date</div>
            <div>Transmittal Attributes</div>
            <div>Reason for Issue</div>
          </div>
          <div class="info-col2">
            <div>Mr Yasin Chipolkar, Air Products ECP</div>
            <div>1</div>
            <div>16/06/2025</div>
            <div>
              In Progress - Expected date 26/06/2025
              <span class="warning-text">
                (0 days after original estimated end date)
              </span>
            </div>
            <div class="dotted-line">
              <span>X</span>
            </div>
            <div>Issued for Review</div>
          </div>
        </div>

        <div class="timeline-box">
          <table class="timeline-table">
            <thead>
              <tr>
                <th>Duration</th>
                <th>4 Days</th>
                <th>2 Days</th>
                <th>Total: 6</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>▶</span>
                </td>
                <td>
                  <div class="step">
                    <div class="step-box">Review (1)</div>
                    <span>○</span>
                  </div>
                </td>
                <td>
                  <div class="step">
                    <span>○</span>
                    <div class="step-box">Consolidation</div>
                    <span>⏹</span>
                  </div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Main;
